export const TENANT_INDUSTRY = {
  COMPANY: "COMPANY",
  FACTORY: "FACTORY",
};

export const DEFAULT_TENANT_INDUSTRY = TENANT_INDUSTRY.COMPANY;

const COMPANY_LABELS = {
  industry: TENANT_INDUSTRY.COMPANY,
  entity: "الشركة",
  entityIndefinite: "شركة",
  entityPlural: "الشركات",
  entityCode: "كود الشركة",
  entityOwner: "مالك الشركة",
  site: "الفرع",
  sitePlural: "الفروع",
  siteManager: "مدير فرع",
  siteScope: "على الفرع",
  incentivesNav: "تارجت المبيعات",
  incentivesPage: "تارجت المبيعات / الإنتاج",
  incentivesSubtitle:
    "اختار تارجت للمبيعات بالشرائح، أو إنتاج: فرق صنايعي ومساعد بمبلغ لكل وحدة.",
  targetPayslip: "التارجت",
  companyWideTarget: "على الشركة",
  companyTarget: "تارجت الشركة",
  siteTarget: "تارجت الفرع",
  weeklyPlan: "الخطة الأسبوعية",
  siteShiftHours: "مواعيد ورديات الفروع",
  siteShiftHoursPage: "مواعيد الورديات للفروع",
};

const FACTORY_LABELS = {
  industry: TENANT_INDUSTRY.FACTORY,
  entity: "المصنع",
  entityIndefinite: "مصنع",
  entityPlural: "المصانع",
  entityCode: "كود المصنع",
  entityOwner: "مالك المصنع",
  site: "الموقع",
  sitePlural: "المواقع",
  siteManager: "مدير المصنع",
  siteScope: "على الموقع",
  incentivesNav: "حوافز الإنتاج",
  incentivesPage: "حوافز التارجت / الإنتاج",
  incentivesSubtitle:
    "اختار تارجت بالشرائح، أو إنتاج: فرق صنايعي ومساعد بمبلغ لكل وحدة.",
  targetPayslip: "حافز الإنتاج",
  companyWideTarget: "على المصنع",
  companyTarget: "تارجت المصنع",
  siteTarget: "تارجت الموقع",
  weeklyPlan: "الخطة الأسبوعية للمواقع",
  siteShiftHours: "مواعيد ورديات المواقع",
  siteShiftHoursPage: "مواعيد الورديات للمواقع (أ / ب / ج)",
};

export function normalizeTenantIndustry(value) {
  if (value === TENANT_INDUSTRY.FACTORY || value === "FACTORY") {
    return TENANT_INDUSTRY.FACTORY;
  }
  return TENANT_INDUSTRY.COMPANY;
}

export function getIndustryLabels(industry) {
  return normalizeTenantIndustry(industry) === TENANT_INDUSTRY.FACTORY
    ? FACTORY_LABELS
    : COMPANY_LABELS;
}
